import { FC, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { store } from 'store';

import * as S from './SearchBar.styles';

// Search any of the 2.5M wallets in the dataset — not just the ~5K displayed.
// Displayed star: camera flight + trader card. Off-screen wallet: switches to
// the Mind view, drops a pulsing guest marker at its behavioral-map spot.
export const SearchBar: FC = observer(() => {
  const [value, setValue] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'error'>('idle');
  const [error, setError] = useState('');
  const timer = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current);
    },
    []
  );

  const showError = (message: string) => {
    setStatus('error');
    setError(message);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      setStatus('idle');
      setError('');
    }, 2600);
  };

  const submit = async () => {
    if (status === 'loading') return;
    setStatus('loading');
    setError('');
    const result = await store.galaxyStore.searchWallet(value);
    if (result === 'invalid') {
      showError('ENTER A FULL 0x… ADDRESS');
    } else if (result === 'not_found') {
      showError('WALLET NOT FOUND');
    } else {
      setStatus('idle');
    }
  };

  return (
    <S.Container>
      <S.Input
        value={value}
        $error={status === 'error'}
        placeholder="Find wallet 0x…"
        spellCheck={false}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') void submit();
        }}
      />
      <S.Button onClick={() => void submit()} disabled={status === 'loading'}>
        {status === 'loading' ? '…' : '➤'}
      </S.Button>
      {error && <S.Error>{error}</S.Error>}
    </S.Container>
  );
});
